import React from 'react';
import { Image, Platform, TouchableOpacity } from 'react-native';
import { ThemedText, ThemedView } from "@app/theme";

interface PhotoPreviewProps {
    userPhoto: string;
    onRetake: () => void;
}

export const PhotoPreview: React.FC<PhotoPreviewProps> = ({ userPhoto, onRetake }) => (
    <ThemedView>
        <Image
            source={{
                uri: Platform.OS === 'web' ? userPhoto : `data:image/jpeg;base64,${userPhoto}`,
            }}
            style={{
                width: 280,
                height: 280,
                borderRadius: 8,
                alignSelf: 'center',
                marginTop: 24
            }}
        />
        <TouchableOpacity activeOpacity={1} onPress={onRetake}>
            <ThemedText
                mt={"md"}
                variant={"b3s"}
                textAlign={"center"}
                color={"text-action-primary"}
            >
                Retake
            </ThemedText>
        </TouchableOpacity>
    </ThemedView>
);